/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileImgShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M9.527 17v-4.87h1.045V17zm1.996 0v-4.87h1.092l1.548 3.208 1.527-3.209h1.092V17H15.75v-3.156l-1.286 2.687h-.643l-1.287-2.646V17zm8.36-2.07v-.563h1.802v2.392a3.815 3.815 0 0 1-1.621.335c-.822 0-1.445-.219-1.87-.657-.42-.437-.63-1.08-.63-1.93 0-.522.103-.966.309-1.333.21-.37.509-.652.898-.844.393-.196.866-.295 1.42-.295.205 0 .409.018.61.054.205.036.397.09.576.16v.885a4.096 4.096 0 0 0-.61-.147 3.1 3.1 0 0 0-.536-.047c-.514 0-.909.136-1.186.409-.272.268-.408.654-.408 1.159 0 .562.118.985.355 1.266.24.277.607.415 1.098.415.21 0 .416-.013.617-.04v-.945zM2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileImgShortcut as FileImgShortcut };
